import styled from 'styled-components';
import {
  ByocOnboardingContainer,
  ByocOnboardingTitle,
  ByocOnboardingText,
  ByocOnboardingButtonContainer
} from 'routes/App/byocOnboarding/styles';

// Re-export common styles with FirstScreen-specific names for backward compatibility
export const SelfDeliveryContainer = ByocOnboardingContainer;
export const FirstScreenTitle = styled(ByocOnboardingTitle)`
  margin-top: 28px;
`;
export const FirstScreenText = styled(ByocOnboardingText)`
  margin-bottom: 27px;
`;

export const FirstScreenBoxContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin: 0;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FirstScreenBox = styled.div`
  border: 1px solid #c4c4c4;
  border-radius: 10px;
  padding: 24px 28px;
  background: #fff;

  display: flex;
  flex-direction: column;
  gap: 12px;
  img {
    width: 28px;
    height: 28px;
  }

  .title {
    font-weight: 700;
    font-size: 16px;
    margin-top: 5px;
    color: #2f3d48;
  }

  .subtitle {
    font-size: 12px;
    color: #2f3d48;
  }
`;

export const FirstScreenButton = ByocOnboardingButtonContainer;
